import { SubscriptionTypes } from 'utils/subscription';
import { IdentityProviderType } from 'models/identity/identityProvider';

export default class Tenant {
  id: string;

  parentId?: string;

  topLevelParentTenantId: string;

  //the directory the tenant signs in with: the provider and its own id for it (an Entra tenant id, a Workspace domain)
  identityProviderType: IdentityProviderType;

  providerTenantId?: string;

  name: string;

  created?: Date;

  subscriptionType: SubscriptionTypes;

  subscriptionEnd?: Date;

  timeZoneCode?: string;

  color?: string;

  //whether the signed-in user holds a license in this tenant (the organization list of the account menu)
  currentUserLicensed?: boolean;

  constructor(id: string, name: string) {
    this.id = id;
    this.topLevelParentTenantId = id; //default same as id
    this.identityProviderType = IdentityProviderType.Entra;
    this.name = name;
    this.subscriptionType = SubscriptionTypes.Trial;
  }

  clone() {
    const newTenant = new Tenant(this.id, this.name);
    newTenant.parentId = this.parentId;
    newTenant.topLevelParentTenantId = this.topLevelParentTenantId;
    newTenant.identityProviderType = this.identityProviderType;
    newTenant.providerTenantId = this.providerTenantId;
    newTenant.created = this.created;
    newTenant.subscriptionType = this.subscriptionType;
    newTenant.subscriptionEnd = this.subscriptionEnd;
    newTenant.timeZoneCode = this.timeZoneCode;
    newTenant.color = this.color;
    newTenant.currentUserLicensed = this.currentUserLicensed;

    return newTenant;
  }
}
